import posthog from "posthog-js";
import { keys } from "./keys";

export const initializeAnalytics = () => {
  posthog.init(keys().NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: keys().NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2025-05-24",
    // Private presentation URLs contain bearer credentials and client-specific paths.
    before_send: (event) => /\/(?:api\/)?presentations?\//.test(JSON.stringify(event?.properties ?? {})) ? null : event,
  });
};
